import { Loader2 } from "lucide-react";

function LoadingRoles() {

    return (

        <div className="loading-state">

            <Loader2
                className="spin"
                size={40}
            />

            <p>Loading roles...</p>

        </div>

    );

}

export default LoadingRoles;